module.exports = __webpack_public_path__ + "media/images/icons/back1-3897a72dc0ade72aaf36093c470155d7.svg";